import { AddSelectOption } from "@/app/components/AddSelectOption";
import { CustomField } from "@/app/components/form-fields/atoms";
import { MultiLevelSelect } from "@/app/components/form-fields/select/MultiLevelSelect";
import { Entity, ISelectField, ISelectFieldOption } from "@/app/fields/types";

export const SelectFormField = <T extends Entity>({
  field,
  options,
  isDisabled,
  onAddOption,
}: {
  field: ISelectField<T>;
  options: ISelectFieldOption[];
  isDisabled?: boolean;
  onAddOption?: (option: ISelectFieldOption) => void;
}) => {
  return (
    <CustomField
      field={field}
      isDisabled={isDisabled}
      addOption={
        field.is_dynamic &&
        !!onAddOption && (
          <AddSelectOption
            fieldName={String(field.field)}
            fieldLabel={field.label}
            onAddSuccess={onAddOption}
            groups={
              options
                .map(({ group }) => group)
                .filter((group) => !!group)
                .filter(
                  (group, index, arr) => arr.indexOf(group) === index
                ) as string[]
            }
          />
        )
      }
      render={({
        field: { onChange, value, name, onBlur },
        fieldState: { invalid },
      }) => (
        <>
          <MultiLevelSelect
            options={options.filter((option) => option.value !== value)}
            isInvalid={invalid}
            label={
              options.find((option) => option.value === value)?.label ||
              "Select a value..."
            }
            isDisabled={isDisabled}
            onBlur={onBlur}
            onOptionClick={({ value }) => onChange(value)}
            onClear={() => onChange(null)}
          />
          <input
            id={`form-field-${name}`}
            className="hidden"
            value={value || ""}
            name={name}
            required={field.is_required}
            disabled={isDisabled}
            onChange={() => {}}
          />
        </>
      )}
    />
  );
};
